import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import {  Field, reduxForm, propTypes,formValueSelector,getFormSyncErrors,change   } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import {   saveSeasonSetup, resetSetupSettings } from "../../../redux/actions/action_seasonsettings"
import { lblattrs6 } from '../../../utils/style'
import { onlypositivenumbers } from '../../../utils/helperfunctions/onlypositivenumbers'
import { defaultformstate } from '../../../utils/statedefaultvalues/formstate'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const formName = 'seasonsetup'
const setupTab = 3
class Setup extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props,context) {
        super(props,context)
        this.handleSaveSetup = this.handleSaveSetup.bind(this) 
        this.handleValueChange       = this.handleValueChange.bind(this)
    }
    componentDidUpdate(){
        const {  initialize,datasaved,resetform,resetSetupSettings,settingsSaved ,setupreset,resetDone,dispatch } = this.props
        if (datasaved) {
            initialize({}, true)
            settingsSaved(true,setupTab)
        }

        if(resetform == true){
            resetSetupSettings()
        }
        if(setupreset == true){
            dispatch(change(formName,'setupreset',false))
            resetDone()
        }
    }
    handleSaveSetup() {
        const { setup, saveSeasonSetup, settingsseason, dispatch } = this.props
        const seasonsettings = setup[settingsseason]      
        const seasonsetup = {
            minT1games:seasonsettings.minT1games,
            minT2games:seasonsettings.minT2games,
            bakerToStandardGamesRatio:seasonsettings.bakerToStandardGamesRatio,
            maxEventDuration:seasonsettings.maxEventDuration,
            tierOneGameMaxThreshold:seasonsettings.tierOneGameMaxThreshold,
            totalGameMaxThreshold:seasonsettings.totalGameMaxThreshold,
            seasonId:settingsseason
        }
        dispatch(change(formName, 'savingdata',true))
        saveSeasonSetup(settingsseason,seasonsetup)
    }
    handleValueChange(){
        const { dispatch, settingsSaved } = this.props
        dispatch(change(formName,'datasaved',false))
        settingsSaved(false,setupTab)
    }
    render()    {
        const { setup,settingsseason,savingdata,datasaved,seasonyears, syncErrors } = this.props
        const season  = `setup[${settingsseason}]`
        const errors =  Object.values(syncErrors)
        let isSeasonSet = true

        if(setup){
            isSeasonSet = setup[settingsseason].isSeasonSet
        }
  
        return (
            <Row className="center-block center-text">
                <form className="form-horizontal" sm={6} style={{ padding:'0',margin:'0' }} >
                    <Col lg={6}>
                                    <FormGroup>
                                        <SeasonHeader seasonyears={seasonyears} />   
                                    </FormGroup>
                                    { (errors.length > 0) && <ErrorList errors={errors}/> }
                                        <FormGroup>
                                            <label className={lblattrs6}>Minimum # of Tier 1  games</label>
                                            <Field
                                                type='number'
                                                name={`${season}.minT1games`}
                                                component='input'
                                                className="form-control no-spinners"
                                                style={{ maxWidth: '70px' }}
                                                max = {99}  
                                                onChange={this.handleValueChange}    
                                                parse={onlypositivenumbers}                                    
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label className={lblattrs6}>Minimum # of Tier 2 games</label>
                                            <Field
                                                type='number'
                                                name={`${season}.minT2games`}
                                                component='input'
                                                className="form-control no-spinners"
                                                style={{ maxWidth: '70px' }}
                                                max = {99}  
                                                onChange={this.handleValueChange}  
                                                parse={onlypositivenumbers}                                      
                                            />                                     
                                        </FormGroup>
                                        <FormGroup>
                                            <label className={lblattrs6}>Baker to standard games ratio</label>
                                            <Field
                                                type='number'
                                                name={`${season}.bakerToStandardGamesRatio`}
                                                component='input'
                                                className="form-control no-spinners"
                                                style={{ maxWidth: '70px' }}
                                                max = {99} 
                                                onChange={this.handleValueChange} 
                                                parse={onlypositivenumbers}                                        
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label className={lblattrs6}>Maximum event duration</label>
                                            <Field
                                                type='number'
                                                name={`${season}.maxEventDuration`}
                                                component='input'
                                                className="form-control no-spinners"
                                                style={{ maxWidth: '70px' }}
                                                max = {4}   
                                                onChange={this.handleValueChange}
                                                parse={onlypositivenumbers}                                       
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label className={lblattrs6}>Tier 1 Events Max Threshold</label>
                                            <Field
                                                type='number'
                                                name={`${season}.tierOneGameMaxThreshold`}
                                                component='input'
                                                className="form-control no-spinners"
                                                style={{ maxWidth: '70px' }}
                                                max = {10}   
                                                onChange={this.handleValueChange}
                                                parse={onlypositivenumbers}                                       
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label className={lblattrs6}>Total Events Max Threshold</label>
                                            <Field
                                                type='number'
                                                name={`${season}.totalGameMaxThreshold`}
                                                component='input'
                                                className="form-control no-spinners"
                                                style={{ maxWidth: '70px' }}
                                                max = {20}   
                                                onChange={this.handleValueChange}
                                                parse={onlypositivenumbers}                                       
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Col lgOffset={ 2 } lg={ 10 }>
                                                <button type="button"   className="btn btn-primary"  style={{ marginLeft:'20px' }} onClick={this.handleSaveSetup} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
                                                    <i className={savingdata == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
                                                </button>
                                                {
                                                        datasaved && (<InfoSaved section='Season setup' />)
                                                }
                                            </Col>
                                        </FormGroup>
                        </Col>
                </form>
                                
        </Row>)
    }
}

function validate(values) {
    const { setup, settingsseason } = values
   
    const errors = {}
 
    if(setup && settingsseason){

            const season = setup[settingsseason]
            const { minT1games, minT2games, bakerToStandardGamesRatio, maxEventDuration, tierOneGameMaxThreshold, totalGameMaxThreshold } = season 
            const isSeasonSet = season.isSeasonSet

            let errorCounter = 0    
            
            if (isSeasonSet) {
    
                // check all values are provided
                if (!minT1games || minT1games <= 0) {
                    errors[errorCounter++] = "Please specify a positive number for minimum number of tier 1 games"
                }
                if (!minT2games || minT2games <= 0) {
                    errors[errorCounter++] = "Please specify a positive number for minimum number of tier 2 games"
                }
                if (!bakerToStandardGamesRatio || bakerToStandardGamesRatio <= 0) {
                    errors[errorCounter++] = "Please specify a positive number for baker to standard games ratio"
                }
                if (!maxEventDuration || maxEventDuration <= 0) {
                    errors[errorCounter++] = "Please specify a positive number for minimum event duration"
                }
                if (!tierOneGameMaxThreshold || tierOneGameMaxThreshold <= 0) {
                  errors[errorCounter++] = "Please specify a positive number for tier one events max threshold"
                }
                if (!totalGameMaxThreshold || totalGameMaxThreshold <= 0) {
                  errors[errorCounter++] = "Please specify a positive number for total events max threshold"
                }
          }
          else {
            if( isSeasonSet != undefined  ){
                errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"
            }
          }
    }
    
    return errors
}
Setup.propTypes = {
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    syncErrors:PropTypes.object,
    settingsseason:PropTypes.number,
    savingdata:PropTypes.bool,
    datasaved:PropTypes.bool,
    seasonyears:PropTypes.string,
    setup:PropTypes.object,
    saveSeasonSetup: PropTypes.func,
    resetSetupSettings: PropTypes.func,
    settingsSaved: PropTypes.func,
    resetform:PropTypes.bool,
    resetDone:PropTypes.func,
    setupreset:PropTypes.bool
}
function mapStateToProps(state,ownProps){

   
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason = selector(state,'settingsseason')
    const setup     = selector(state,'setup')
    const setupreset     = selector(state,'setupreset')
    const savingdata     = selector(state,'savingdata')
    const datasaved     = selector(state,'datasaved')
    const syncErrors = getFormSyncErrors(formName)(state)
    return {     
        settingsseason,
        setup,
        setupreset,
        savingdata,
        datasaved,
        syncErrors  
    }
}
function mapDispatchToProps(dispatch){
    return bindActionCreators({
        saveSeasonSetup,
        resetSetupSettings
    },dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  initialValues:defaultformstate,
  enableReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Setup))




// WEBPACK FOOTER //
// ./src/containers/season/Components/Setup.js